var _path, _circle, _circle2, _circle3, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvmLight = function SvgEvmLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#383D51",
    strokeWidth: 0.295,
    d: "M.148 1.182C.148.61.61.148 1.182.148h23.636c.571 0 1.034.463 1.034 1.034v23.636c0 .571-.463 1.034-1.034 1.034H1.182a1.034 1.034 0 0 1-1.034-1.034V1.182Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.808,
    cy: 2.214,
    r: 1.034,
    fill: "#383D51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.466,
    cy: 2.214,
    r: 1.034,
    fill: "#383D51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.126,
    cy: 2.214,
    r: 1.034,
    fill: "#383D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#383D51",
    fillRule: "evenodd",
    d: "M21.95 1.266a.296.296 0 0 1 .418 0l.677.678.677-.678a.296.296 0 0 1 .418.418l-.677.678.677.677a.295.295 0 1 1-.418.418l-.677-.678-.677.678a.296.296 0 0 1-.418-.418l.677-.677-.677-.678a.295.295 0 0 1 0-.418",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.818,
    height: 11.818,
    x: 1.773,
    y: 8.865,
    fill: "#fff",
    rx: 1.477
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m3.266 10.09 3.823 2.904-.623-1.673zM2.758 16.739l.738 2.216 2.232-.74-1.067-1.492z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m5.544 13.878-.585 1.139 2.247.061-.216-2.523zM5.728 18.216l1.238-.493-1.115-.985z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7CCC8",
    d: "m5.728 18.217 1.184.708.054-1.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "m5.727 18.216.123-1.478h-1.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m7.112 15.016-.191 1.195.255 1.313.057-1.73z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    d: "m2.772 11.567.74 3.2 2.05-.687 1.396-1.282-3.693-2.708z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m6.959 16.063-1.97-1.047.574-.934-2.051.688-.754 1.97H5.85l1.116.985.21-.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "m5.851 15.877 1.108.37.154-1.231H4.989z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m6.959 16.246-1.108-.369.769-.37z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m8.92 11.32-.622 1.674 3.823-2.904zM10.725 16.723l-1.059 1.493 2.223.739.739-2.216z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m8.374 12.617-.11 2.484 2.164-.083-.515-.985zM9.535 16.738l-1.107.985 1.238.493z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7CCC8",
    d: "m8.428 17.725.046 1.2 1.193-.708z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "M10.735 16.738h-1.2l.131 1.478z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCAAA4",
    d: "M8.52 18.817v-.356H6.866v.356l-1.138-.602 1.23.985h1.47l1.239-.985z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    d: "m12.12 10.09-3.684 2.708 1.387 1.282 2.06.688.73-3.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m11.883 14.77-2.059-.688.574.934-1.944 1.127-.18-1.127-.12.778.056 1.73.218.2 1.108-.984h3.093z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m6.466 11.326.492 1.477.164 2.3.05.698.004 1.727h.516v-.011.01h.518l.004-1.726.05-.699.172-2.299.492-1.477z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m8.436 17.727-.232-.247H7.182l-.223.247-.093.738H8.52z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "M10.397 15.016H8.273l.154 1.23 1.108-.369z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m8.774 15.508.762.37-1.108.368z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DFE5EC",
    strokeWidth: 0.091,
    d: "M21.15 9.75h-3.3a3.373 3.373 0 0 0-3.373 3.373v3.3a3.373 3.373 0 0 0 3.372 3.373h3.3a3.373 3.373 0 0 0 3.373-3.373v-3.3a3.373 3.373 0 0 0-3.373-3.373Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3375BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.554,
    d: "M19.532 12.057c.942.786 2.022.738 2.33.738-.067 4.474-.582 3.586-2.33 4.841-1.75-1.255-2.26-.367-2.328-4.841.305 0 1.386.048 2.328-.738"
  })));
};
export { SvgEvmLight as ReactComponent };